import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { BonusIntroSection } from '../components/BonusIntroSection';
import { BonusCardsSection } from '../components/BonusCardsSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { BonusClosingSection } from '../components/BonusClosingSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
const META_PIXEL_ID = '1248476953463026';
export function LandingPage() {
  const [orderBump1Selected, setOrderBump1Selected] = useState(false);
  const [orderBump2Selected, setOrderBump2Selected] = useState(false);
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-300 selection:bg-amber-500/30 selection:text-amber-200 overflow-hidden" data-id="element-287">
      <main data-id="element-288">
        <HeroSection data-id="element-289" />
        <ProblemSection data-id="element-290" />
        <FailedSolutions data-id="element-291" />
        <MechanismSection data-id="element-292" />
        <DeliverablesSection data-id="element-293" />
        <AudienceSection data-id="element-294" />
        <ProcessSection data-id="element-295" />
        <ProofSection data-id="element-296" />
        <FAQSection data-id="element-297" />
        <BonusIntroSection data-id="element-298" />
        <BonusCardsSection data-id="element-299" />
        <ValueStackSection data-id="element-300" />
        <BonusClosingSection orderBump1Selected={orderBump1Selected} setOrderBump1Selected={setOrderBump1Selected} orderBump2Selected={orderBump2Selected} setOrderBump2Selected={setOrderBump2Selected} data-id="element-301" />
        <OfferSection orderBump1Selected={orderBump1Selected} orderBump2Selected={orderBump2Selected} data-id="element-302" />
      </main>
      <FooterSection data-id="element-303" />
    </div>;
}